<template>
    <div>
        <div v-if="!loading" class="style_banniere py-5">
            <div class="container text-center py-5">
                <div class="col-md-8 mx-auto">
                    <h5 class="gothic">Bienvenu sur Ross Support</h5>
                    <h1 class="display-3 gothic">Votre compte activé avec succès.</h1>
                </div>
                <router-link class="btn btn-lg btn-dark" :to="{name: 'home'}"><span class="mx-3">Home</span></router-link>
            </div>
        </div><loader v-else/>
    </div>
</template>
<script>
export default {
    name: 'email',
    data() {
        return {loading: true}
    },
    created() {
        this.$store.dispatch("register", this.$route.params).then(() => this.loading = false); 
    },
}
</script>
<style lang="scss"></style>